<template>
  <div class="milepost">
    <div class="header">
      <div class="title">公司简介</div>
      <div class="border"></div>
    </div>

    <div class="body">
      上海畅月物业管理有限公司，是一家致力于为传统物业提供新型的数字智慧物管模式的公司：通过数字化、线上化、智慧化打造综合岗位集合的指挥室。畅居数字化智慧物业平台的三个板块——“物业管理板块”和“物联网管理板块”及“智慧便民商圈板块”组成。公司项目包含：物业管理、酒店管理、市政设施管理、信息系统集成服务、物联网应用服务、信息技术咨询服务等智慧社区+数字化城市治理综合管理系统。
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

export default {
  setup() {
    return reactive({});
  }
};
</script>

<style scoped>
.milepost {
  width: 100%;
  height: 300px;
  margin: 24px auto 0;
  background-image: url(../../../assets/about/mobileaboutback.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
}
.header .title {
  font-size: 16px;
  text-align: center;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}
.body {
  width: 92vw;
  margin: 16px auto;
  font-size: 12px;
  color: #495a6c;
}
</style>
